import {AppMode, Marketplace, Shop, ShopType} from "./types";
import {useMemo} from "react";
import hangerIcon from "./hanger.svg";
import serviceIcon from "./service-icon.svg";
import digitalerMarktplatz from "./digitalermarktplatz.svg";
import apothekeIcon from "./apotheke.svg";
import {COLOR_PRIMARY} from "./themes";
import {useLocalization} from "../i18n";

export function useMarketplaceLauncherItem(marketplace: Marketplace | undefined, mode: AppMode) {
    const {t} = useLocalization();
    return useMemo(() => {
        if (marketplace?.id == "digitalermarktplatz") {
            return {
                id: "marketplace",
                title: marketplace.title,
                description: "Online bestellen, hier abholen",
                icon: digitalerMarktplatz,
                color: "#990000"
            }
        }
        if (marketplace) {
            return {
                id: "marketplace",
                title: marketplace.title,
                description: mode == AppMode.Marketplace ? t("appDescriptionMarketplace") : t("appDescriptionDryCleaning"),
                icon: mode == AppMode.Marketplace ? serviceIcon : hangerIcon,
                color: COLOR_PRIMARY
            }
        }
        else {
            return {
                id: "marketplace",
                title: mode == AppMode.Marketplace ? t("appNameMarketplace") : t("appNameDryCleaning"),
                description: mode == AppMode.Marketplace ? t("appDescriptionMarketplace") : t("appDescriptionDryCleaning"),
                icon: mode == AppMode.Marketplace ? serviceIcon : hangerIcon,
                color: COLOR_PRIMARY
            }
        }
    }, [marketplace, mode]);
}

export function getShopLauncherItem(shop: Shop, dryCleaningAppDescription: string) {
    if (shop.name.toLowerCase().indexOf("apotheke") >= 0) {
        return {
            id: shop.id,
            title: shop.name,
            description: (shop.offer.shortDescription ?? ""),
            icon: apothekeIcon,
            color: "#fff",
            shop: shop.id,
        }
    }
    return {
        id: shop.id,
        title: shop.name,
        description: shop.shopType == ShopType.DryCleaning ? dryCleaningAppDescription : (shop.offer.shortDescription ?? ""),
        icon: shop.shopType == ShopType.DryCleaning ? hangerIcon : shop.logoUrl,
        color: shop.shopType == ShopType.DryCleaning ? COLOR_PRIMARY : "transparent",
        shop: shop.id,
    }
}